// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
/* eslint-disable camelcase */

import { createAsyncAction } from 'typesafe-actions';
import { Progress } from '../../../types/Model';

export interface UpdateWorkshopProgressRequestPayload {
  id: number;
  progress: Progress;
  onSuccess: () => void;
}
export interface UpdateWorkshopProgressSuccessPayload {
  id: number;
  progress: Progress[];
}

export interface UpdateWorkshopProgressFailPayload {
  error: Error;
}

const updateWorkshopProgressActions = createAsyncAction(
  'elearning/UPDATE_WORKSHOP_PROGRESS_REQUEST',
  'elearning/UPDATE_WORKSHOP_PROGRESS_SUCCESS',
  'elearning/UPDATE_WORKSHOP_PROGRESS_FAIL'
)<UpdateWorkshopProgressRequestPayload, UpdateWorkshopProgressSuccessPayload, UpdateWorkshopProgressFailPayload>();

export { updateWorkshopProgressActions as default };
